import { useEffect } from 'react';
import './styles.scss';

export default function HoldOnOverlay() {
  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, []);

  return (
    <div
      className="hold-on-overlay"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="hold-on-title"
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.preventDefault()}
    >
      <div className="hold-on-overlay__card">
        <p className="hold-on-overlay__eyebrow">PolyTechnic</p>
        <h1 id="hold-on-title" className="hold-on-overlay__title">Hold on</h1>
        <p className="hold-on-overlay__message">
          Access is temporarily unavailable.
          Please check back later.
        </p>
      </div>
    </div>
  );
}
